import BasicSwiper from "./index.vue"

export default BasicSwiper